<template>
  <div>
    <div class="preview-invoice" @click="openInvoice">
      <div class="preview-invoice__col preview-invoice__id ">
          <span class="preview-invoice__text">{{ id | preparedString }}</span>
          <copy :value="id" />
      </div>
      <p class=" preview-invoice__col preview-invoice__text ">
        {{ createdAt | getFormatDate('DD/MM/YYYY, HH:mm') }}
      </p>
      <p class=" preview-invoice__col preview-invoice__text preview-invoice__network-name ">
        {{ invoiceNumber }}
      </p>
      <div class="preview-invoice__col preview-invoice__currency ">
          <CurrencyIcon :currency="currency" />
        <p class="preview-invoice__text">{{ currency }}</p>
      </div>
      <div class="preview-invoice__col preview-invoice__text">
        {{ amount }}
      </div>
        <div v-if="item.receivedCurrencyName && item.rate" class="preview-invoice__col preview-invoice__text">
            <span>1 {{ item.receivedCurrencyName }}</span>
            <svg class="info__rate-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7099 1.06102C16.2496 -1.63937e-07 14.1664 -2.54996e-07 10 -4.37114e-07C5.83363 -6.19232e-07 3.75045 -7.10291e-07 2.29008 1.06102C1.81844 1.40368 1.40368 1.81844 1.06101 2.29008C-1.63937e-07 3.75045 -2.54996e-07 5.83363 -4.37114e-07 10C-6.19232e-07 14.1664 -7.10291e-07 16.2496 1.06101 17.7099C1.40368 18.1816 1.81844 18.5963 2.29008 18.939C3.75045 20 5.83363 20 10 20C14.1664 20 16.2496 20 17.7099 18.939C18.1816 18.5963 18.5963 18.1816 18.939 17.7099C20 16.2496 20 14.1664 20 10C20 5.83363 20 3.75045 18.939 2.29008C18.5963 1.81844 18.1816 1.40368 17.7099 1.06102ZM15.6682 12.1778C15.9838 12.4921 16.2824 12.8759 16.3638 13.387C16.3805 13.4919 16.3889 13.5977 16.3889 13.7038C16.3889 13.8099 16.3805 13.9157 16.3638 14.0206C16.2824 14.5316 15.9838 14.9155 15.6682 15.2298C15.3641 15.5328 14.9424 15.8672 14.4534 16.2549L13.1103 17.3197C12.7497 17.6057 12.2256 17.5451 11.9396 17.1845C11.6537 16.8239 11.7142 16.2997 12.0748 16.0138L13.3808 14.9783C13.5932 14.8099 13.7757 14.665 13.9328 14.5371L5.18518 14.5371C4.72494 14.5371 4.35185 14.164 4.35185 13.7038C4.35185 13.2436 4.72494 12.8705 5.18518 12.8705L13.9328 12.8705C13.7757 12.7426 13.5932 12.5977 13.3807 12.4293L12.0748 11.3938C11.7142 11.1079 11.6537 10.5837 11.9396 10.2231C12.2256 9.86246 12.7497 9.80191 13.1103 10.0879L14.4533 11.1527C14.9423 11.5404 15.3641 11.8748 15.6682 12.1778ZM14.815 7.12963C15.2752 7.12963 15.6483 6.75653 15.6483 6.2963C15.6483 5.83606 15.2752 5.46296 14.815 5.46296L6.06733 5.46296C6.22451 5.33514 6.40701 5.19019 6.61943 5.02176L7.92533 3.98631C8.28596 3.70037 8.34651 3.17622 8.06057 2.81559C7.77463 2.45496 7.25048 2.39441 6.88984 2.68035L5.54683 3.74521C5.05784 4.1329 4.63609 4.46726 4.33193 4.77025C4.01637 5.08459 3.71783 5.46845 3.6364 5.9795C3.6197 6.08435 3.61129 6.19021 3.61129 6.2963C3.61129 6.40238 3.6197 6.50824 3.6364 6.6131C3.71783 7.12415 4.01638 7.508 4.33194 7.82234C4.63609 8.12533 5.05783 8.45969 5.54681 8.84736L6.88984 9.91224C7.25048 10.1982 7.77463 10.1376 8.06057 9.777C8.34651 9.41637 8.28596 8.89222 7.92533 8.60628L6.61943 7.57084C6.40701 7.40241 6.22451 7.25745 6.06733 7.12963L14.815 7.12963Z" fill="var(--new-front-secondary-font-color)"/>
            </svg>
            <span>{{ rate }} {{ item.currencyName }}</span>
        </div>
        <p class="preview-invoice__col preview-invoice__text" v-else>
            -
        </p>
      <div class="preview-invoice__col preview-invoice__currency " v-if="receivedCurrencyId">
          <CurrencyIcon :currency="receivedCurrency" />
        <p class="preview-invoice__text">{{ currencyAlias }}&ensp; <span class="preview-invoice__text-secondary">{{ receivedCurrencyName }}</span></p>
      </div>
        <p class="preview-invoice__col preview-invoice__text" v-else>
            -
        </p>

        <div class="preview-invoice__col preview-invoice__currency " v-if="receivedNetworkId">
            <NetworkIcon :network="receivedNetwork.toUpperCase()" />
            <p class="preview-invoice__text">{{ receivedNetwork | getNetworkFullNameByNetworkName }}&ensp; <span class="preview-invoice__text-secondary">{{ receivedNetwork | getNetworkShortNameByNetworkName }}</span></p>
        </div>
      <p class="preview-invoice__col preview-invoice__text" v-else>
        -
      </p>
        <p class="preview-invoice__col preview-invoice__text" v-if="item.orderAmount">
            {{ orderAmount }}
        </p>
        <p class="preview-invoice__col preview-invoice__text" v-else>
            -
        </p>
      <p v-if="receivedAmount || receivedCurrencyId" class="preview-invoice__col preview-invoice__text">
        {{ receivedAmount }}
      </p>
        <p class="preview-invoice__col preview-invoice__text" v-else>
            -
        </p>
        <div class="preview-invoice__col preview-invoice__id" v-if="orderId">
            <span class="preview-invoice__text">{{ orderId | preparedString }}</span>
            <copy :value="orderId" />
        </div>
        <p class="preview-invoice__col preview-invoice__text" v-else>
            -
        </p>
      <div class="preview-invoice__col preview-invoice__tag" :style="`--colorText: ${status.colorTag === 'default' ? 'var(--primary-font-color)' : '#FFFFFF'}`">
        <div :class="['item__status', `item__status--${status.colorTag}`]">
          {{ $t(status.title) }}
        </div>
      </div>
    </div>

    <div :class="['preview-invoice__mobile', isPreviewOpened ? 'preview-invoice__mobile--opened' : '']" :style="`--colorStatus:${mobileStatusTextColor};`">
        <div class="preview-invoice__preview" slot="title" @click="togglePreview">
            <div class=" preview-invoice__currency">
                <CurrencyIcon
                        class="preview-invoice__currency-img"
                        :currency="currency"
                />
                <div class="preview-invoice__currency-container">

                    <p class="preview-invoice__currency-text">
                        {{ currency }}</p>
                </div>

            </div>
            <svg :class="['preview-invoice__chevron', isPreviewOpened ?  'preview-invoice__chevron--active' : '']" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.228 1.635C0.085 1.462 0 1.241 0 1C0 0.448 0.448 0 1 0H7C7.552 0 8 0.448 8 1C8 1.241 7.915 1.462 7.772 1.635L4.808 5.589C4.626 5.838 4.332 6 4 6C3.668 6 3.374 5.838 3.192 5.589L0.228 1.635Z" fill="var(--new-front-primary-font-color)"/>
            </svg>
        </div>

        <div class="preview-invoice__detailed-info">
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text">id</p>
                <p class="preview-invoice__text">
                    {{ id | preparedString }}
                    <copy :value="id"/>
                </p>
            </div>
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text"> {{ $t('invoice.date_of_creation') }}</p>
                <p class="preview-invoice__text">
                    {{ createdAt | getFormatDate('DD/MM/YYYY, HH:mm') }}
                </p>
            </div>
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text"> {{ $t('invoice.account_number') }}</p>
                <p class="preview-invoice__text">
                    {{ invoiceNumber }}
                </p>
            </div>
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text"> {{ $t('invoice.payment_currency') }}</p>
                <div class=" preview-invoice__currency" v-if="receivedCurrencyId">
                    <CurrencyIcon
                            class="preview-invoice__currency-img"
                            :currency="receivedCurrency"
                    />
                    <div class="preview-invoice__currency-container">

                        <p class="preview-invoice__text">{{ currencyAlias }} <span class="preview-invoice__text-secondary">{{ receivedCurrencyName }}</span></p>
                    </div>
                </div>
                <p class="  preview-invoice__text" v-else>-</p>
            </div>
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text"> {{ $t('invoice.order') }}</p>
                <p class="preview-invoice__text" v-if="orderId">
                    {{ orderId | preparedString }}
                    <copy :value="orderId"/>
                </p>
                <p class="  preview-invoice__text" v-else>-</p>
            </div>
            <div class="preview-invoice__row">
                <p class="preview-invoice__title-text"> {{ $t('invoice.status') }}</p>
                <div class="preview-invoice__tag" :style="`--colorText: ${status.colorTag === 'default' ? 'var(--primary-font-color)' : '#FFFFFF'}`">
                    <div :class="['item__status', `item__status--${status.colorTag}`]">
                        {{ $t(status.title) }}
                    </div>
                </div>
            </div>
            <base-button :type="'primary'" :label="$t('orders.more')" class="preview-invoice__btn" @click="openInvoice"/>
        </div>
    </div>

  </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import BigNumber from "bignumber.js";
    import CopyString from "/public/components/elements/CopyString";
    import CurrencyImg from "/public/components/elements/CurrencyImg";
    import AtTag from 'at-ui/src/components/tag';
    import AtCollapse from 'at-ui/src/components/collapse/';
    import AtCollapseItem from 'at-ui/src/components/collapse-item/';
import Copy from "@/public/components/common/copy.vue";
import CurrencyIcon from "@/public/components/common/uiKit/CurrencyIcon.vue";
import {getCurrencyInfoById, getNetworkSystemName} from "@/public/filters";
import NetworkIcon from "@/public/components/common/uiKit/NetworkIcon.vue";
import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";

    export default {
    name: 'PreviewInvoice',
    components: {
        BaseButton,
        NetworkIcon,
        CurrencyIcon,
        Copy,
        CopyString,
        CurrencyImg,
        AtTag,
        AtCollapse,
        AtCollapseItem,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        isLink: {
            type: Boolean,
            default: true,

        },

        statusEnum: {
            type: Object,
            required: true,
        },
        orderEnum: {
            type: Object,
            required: true,
        },
        mobileStatusTextColor: {
            type: String,
            required: true,
        },
    },
    data () {
      return {
          isPreviewOpened: false
      }
    },
    computed: {
        ...mapGetters('app', [
            'getCurrencyNameById',
        ]),
        rate () {
          return BigNumber(this.item.rate).toFixed(3)
        },
        currencyAlias () {
          return getCurrencyInfoById(this.item.receivedCurrency).alias
        },
        id() {
            return this.item.id;
        },
        order() {
            return this.item;
        },
        orderId() {
            return this.item.orderId;
        },
        account() {
            return this.item.account ? this.item.account : 'пусто';
        },
        networkId() {
            return this.item.networkId;
        },

        currency() {
            const {
                item: {currency, currencyId},
                getCurrencyNameById,
            } = this;

            return getCurrencyNameById(currency || currencyId);
        },
        receivedCurrency() {
            const {
                item: {receivedCurrency},
                getCurrencyNameById,
            } = this;

            return getCurrencyNameById(receivedCurrency);
        },
        receivedNetwork () {
            return getNetworkSystemName(this.receivedNetworkId)
        },
        received() {
            return Number(this.item.received)
        },
        amount({ item }) {
            return item.amount !== 'NaN' ? ( item.amount && Number(item.amount) ) : ''
        },
        orderAmount({ item }) {
          return item.orderAmount && Number(item.orderAmount)
        },
        receivedAmount() {
            return Number(this.item.receivedAmount)
        },
        receivedCurrencyName() {
            return `(${this.item.receivedCurrencyName})`;
        },
        receivedCurrencyId() {
            return this.item.receivedCurrency;
        },
        receivedNetworkId() {
            return this.item.receivedNetworkId;
        },
        invoiceNumber() {
            return this.item.itemId;
        },
        status() {
            const {
                statusEnum,
                item,
            } = this;

            return statusEnum[item.status];
        },
        createdAt() {
            return this.item.createdAt;
        },
        id_copied() {
            return this.$t('copy.id_copied');
        },
        id_not_copied() {
            return this.$t('copy.id_not_copied');
        },
        notification() {
            return this.$t('copy.notification');
        },
        addresses_copied() {
            return this.$t('copy.addresses_copied');
        },
        addresses_not_copied() {
            return this.$t('copy.addresses_not_copied');
        },

    },
    methods: {
      openInvoice () {
          this.$emit('openInvoice', this.id)
      },
        togglePreview () {
          this.isPreviewOpened = !this.isPreviewOpened
        }
    },
};

</script>

<style lang="scss" scoped>
p {
  word-break: break-word;
}
.item__status {
  width: 120px;
  height: 32px;
  border-radius: 10px;
  text-align: center;
  padding: 5px 15px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  &--active {
    color: var(--new-front-status-text-active);
    background: var(--new-front-status-active);
  }
  &--created {
    color: var(--new-front-status-text-active);
    background: var(--new-front-status-active);
  }
  &--expired {
    color: var(--new-front-status-text-expired);
    background: var(--new-front-status-expired);
  }
  &--completed {
    color: var(--new-front-status-text-processed);
    background: var(--new-front-status-processed);
  }
  &--in_processing {
    color: var(--new-front-status-text-pending);
    background: var(--new-front-status-pending);
  }
  &--partial_payment {
    color: var(--new-front-status-text-pending);
    background: var(--new-front-status-pending);
  }
  &--overpaid {
    color: var(--new-front-status-text-processed);
    background: var(--new-front-status-processed);
  }
  &--error {
    color: var(--new-front-status-text-error);
    background: var(--new-front-status-error);
  }
}
.preview-invoice {
  position: relative;
  align-items: center;
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20% 25% 20% 25% 20% 20% 20% 20%;
  @media screen and (max-width: 1600px) {
    grid-template-columns: 20% 20% 20% 20% 20% 30% 30% 35% 20% 20% 20% 20%;
  }
  min-height: 88px;
  background: var(--new-front-main-bg);
  color: var(--new-front-primary-font-color);
  cursor: pointer;
  &__chevron {
    transition: transform .3s ease;
    &--active {
      transform: rotate(180deg);
    }
  }
  &:hover {
    //background: var(--primary-color);
    & .preview-invoice__col {
      //background: var(--primary-color);
    }
  }
  &__col {
    min-height: 58px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--new-front-divider-color);
    height: 85px;
    &:first-child {
      padding-left: 40px;
    }
  }
  &__text {
    display: flex;
    align-items: center;
    font-family: $Gilroy;
    font-size: $h4;
    font-weight: 500;
    line-height: var(--line-height);
    color: var(--new-front-primary-font-color);
    &-secondary {
      color: var(--new-front-secondary-font-color);
    }
  }

  &__mobile {
    display: none;
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 193%;
    height: 100%;
    z-index: 0;
    border-bottom: 1px solid var(--new-front-divider-color);
  }

  &__tag ::v-deep .at-tag {
    min-height: 30px;
    display: flex;
    align-items: center;
    width: 87px;
    border-radius: 8px;
    justify-content: center;
  }
  &__tag ::v-deep .at-tag--default {
    background: var(--new-front-main-bg);
    color: var(--primary-font-color);
    border: 1px solid var(--border-color);
  }
  &__tag ::v-deep .at-tag__text {
    font-style: normal;
    font-family: var(--font-family);
    font-size: var(--font-size-text-secondary);
    line-height: var(--line-height);
    color: var(--colorText);
    white-space: normal;
  }

  &__id {
    position: relative;
    z-index: 2;

    &::v-deep p {
      word-break: break-word;
      font-family: var(--font-family);
      font-size: var(--font-size-text-main);
      line-height: var(--line-height);
    }
  }

  &__currency {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  &__currency-img {
    //margin-right: 12px;
    width: 24px;
    height: 24px;
  }
}

//@media screen and (max-width: 1300px) {
//  .preview-invoice {
//    padding-right: 10px;
//    padding-left: 30px;
//  }
//}

@media screen and (max-width: 950px) {
  .preview-invoice {
    display: none;

    &__detailed-info {
      align-items: center;
      display: flex;
      flex-direction: column;
    }

    &__read-more {
      width: 100%;
      max-width: 300px;
      border-radius: 12px;
      background: #0059F7;
      font-family: $Gilroy;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #FFFFFF;
      min-height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 25px;
      margin-bottom: 20px;
    }

    &__currency-text {
      font-family: $Gilroy;
      font-style: normal;
      font-weight: 500;
      font-size: $h4;
      line-height: var(--line-height);
      color: var(--new-front-primary-font-color)
    }

    &__currency-status {
      font-family: $Gilroy;
      font-style: normal;
      font-weight: 400;
      font-size: var(--font-size-text-caption);
      line-height: var(--line-height);
      color: var(--colorStatus);
    }

    &__currency-amount {
      font-family: $Gilroy;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      color: var(--primary-font-color)
    }

    &__currency-container {
      display: flex;
      flex-direction: column;
    }
    &__btn {
      margin: 20px 0;
    }
    &__row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 53px;
      border-bottom: 1px solid var(--new-front-divider-color);
      color: var(--new-front-primary-font-color);

      //&:hover {
      //  background: var(--primary-color);
      //}
      &:last-of-type {
        border-bottom: none;
      }
    }

    &__title-text {
      font-family: $Gilroy;
      font-style: normal;
      font-weight: 500;
      font-size: $h6;
      line-height: 16px;
      color: var(--new-front-secondary-font-color);
    }

    &__preview {
      display: flex;
      justify-content: space-between;
      flex: 1;
      align-items: center;
      height: 68px;
    }


    &__mobile {
      display: block;
      padding: 0 20px;
      border-bottom: 1px solid var(--new-front-divider-color);
      max-height: 68px;
      overflow: hidden;
      transition: max-height .3s ease;
      &--opened {
        max-height: 500px;
      }
    }

  }
.preview-invoice__text {
  font-size: $h5;
}
}
::v-deep .at-collapse__content {
  background: var(--new-front-main-bg);
}
.info__rate-icon {
  margin: 0 10px;
}
::v-deep .copy-wrapper {
  margin-right: 0;
}
</style>
